export type LegalGuardianStatusDescriptor = {
  name: string;
  value: number;
  description: string;
}

export class LegalGuardianConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  // Discrete states
  static readonly LG_UNKNOWN: number = 0;  // Must match lookup value
  static readonly LG_INITIATED: number = 1;  // Must match lookup value
  static readonly LG_APPROVED: number = 2;  // Must match lookup value
  static readonly LG_DENIED: number = 3;  // Must match lookup value
  static readonly LG_CANCELED: number = 4;  // Must match lookup value
  static readonly LG_TERMINATED: number = 5;  // Must match lookup value

  // State groups
  static readonly LG_PENDING_GROUP: number[] = [1];  // Must match lookup value
  static readonly LG_NOT_APPROVED_GROUP: number[] = [3,5];  // Must match lookup value
  static readonly LG_TERMINAL_GROUP: number[] = [3,4,5]; // Must match lookup value

  static status: LegalGuardianStatusDescriptor[] = [
    { name: "Unknown", value: this.LG_UNKNOWN, description: "None or Unknown" },
    { name: "Initiated", value: this.LG_INITIATED, description: "Initiated by Health Record Owner"},
    { name: "Approved", value: this.LG_APPROVED, description: "Approved by Survivor Clinic or SurvivorLink"},
    { name: "Deny", value: this.LG_DENIED, description: "Denied by Survivor Clinic or SurvivorLink"},
    { name: "Canceled", value: this.LG_CANCELED, description: "Canceled by Health Record Owner"},
    { name: "Terminated", value: this.LG_TERMINATED, description: "Terminated by Survivor Clinic or SurvivorLink"},
  ]




}

